import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-disable.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const DisableIcon = createSvgIcon(<Icon />, 'DisableIcon');
